var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"container",staticClass:"realtime-container"},[_c('div',{ref:"canvas",staticClass:"realtime-scada"})])
}
var staticRenderFns = []

export { render, staticRenderFns }